import { render, staticRenderFns } from "./DialogPromoLocal.vue?vue&type=template&id=2fa0db46"
import script from "./DialogPromoLocal.vue?vue&type=script&lang=js"
export * from "./DialogPromoLocal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports